import i18next from 'i18next';

import { GET_STORE_REGION } from 'constants/storeRegions';
import * as api from 'services/ErplyAPI/storeRegions';
import { getLoggedInWarehouse } from 'reducers/warehouses';
import { Warehouse } from 'types/Warehouse';
import { STORE_REGION } from 'containers/EssentialDataLoader/constants';
import { createAsyncThunkWithIndexedDbPersister } from 'containers/EssentialDataLoader/utils';

import { CAFA_LEVELS } from '../constants/CAFA';

export const getStoreRegionAssociatedWithSelectedWarehouse = createAsyncThunkWithIndexedDbPersister(
  STORE_REGION,
  GET_STORE_REGION,
  async (_, { getState }) => {
    const selectedWarehouse: Warehouse = getLoggedInWarehouse(getState());
    if (!selectedWarehouse)
      throw new Error(i18next.t('alerts:errors.earlyStoreRegionFetch'));
    if (!selectedWarehouse.storeRegionID) return null;

    const storeRegions = await api.getStoreRegions({
      getPriceLists: 1,
      getCustomerGroupPriceLists: 1,
    });
    const selectedStoreRegion = storeRegions.find(
      storeRegion =>
        Number(storeRegion.storeRegionID) ===
        Number(selectedWarehouse.storeRegionID),
    );

    return selectedStoreRegion ?? null;
  },
  {
    provideLevel: state => {
      const warehouse: Warehouse = getLoggedInWarehouse(state);
      return {
        level: CAFA_LEVELS.Warehouse,
        id: String(warehouse.warehouseID),
      };
    },
  },
);
